var render = function render(){var _vm=this,_c=_vm._self._c;return _c('FullScreenTemperatureChart',{attrs:{"is-visible":_vm.isVisible,"has-data":"","asset-name":_vm.assetName,"temperature-data":_vm.temperatures,"space-data":_vm.spaceData},on:{"close":function($event){return _vm.$emit('close')}}})
}
var staticRenderFns = []

export { render, staticRenderFns }